import * as React from 'react';
const SeparatorCore = (props) => {
    const { color, weight, spacing, align, fullWidth, children, className, content, element: Element = 'div', } = props;
    const BEM = () => {
        const classArray = ['separator'];
        if (color) {
            classArray.push(`separator--color-${color}`);
        }
        if (weight) {
            classArray.push(`separator--${weight}`);
        }
        if (spacing) {
            classArray.push(`separator--${spacing}`);
        }
        if (align) {
            classArray.push(`separator--${align}`);
        }
        if (fullWidth) {
            classArray.push('separator--full-width');
        }
        if (children) {
            classArray.push('separator--content');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const TopElement = Element === 'span' ? 'span' : 'div';
    if (children) {
        return (React.createElement(TopElement, { className: BEM() },
            Element === 'hr' && React.createElement(Element, { className: "sr-only" }),
            React.createElement(TopElement, { className: "separator__content" }, children)));
    }
    if (content) {
        return (React.createElement(TopElement, { className: BEM() },
            Element === 'hr' && React.createElement(Element, { className: "sr-only" }),
            content));
    }
    return (React.createElement(Element, { className: BEM() }));
};
export { SeparatorCore as default, };
